"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

var _Modifiers = require("./../utils/Modifiers");

var _DropdownButton = _interopRequireDefault(require("react-bootstrap/DropdownButton"));

require("./AddCustomAttribute.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var addCustomAttr = function addCustomAttr(attr, label, editorState, onChangeEditorState) {
  onChangeEditorState((0, _Modifiers.addTextEntity)(editorState, label, 'mention', {
    mention: {
      name: label,
      attr: attr
    }
  }));
};

var _default = function _default(config) {
  if (config === void 0) {
    config = {};
  }

  var _config = config,
      customAttributes = _config.customAttributes;

  var AddAttribute = function AddAttribute(_ref) {
    var editorState = _ref.editorState,
        onChangeEditorState = _ref.onChangeEditorState,
        key = _ref.key;
    return /*#__PURE__*/_react["default"].createElement(_DropdownButton["default"], {
      className: "shadow card mx-2",
      variant: "transparent",
      key: key,
      title: "Add Attribute",
      id: "addAttribute",
      size: "sm"
    }, customAttributes && customAttributes.length ? customAttributes.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Dropdown.Item, {
        key: item.attr + index,
        onSelect: function onSelect() {
          addCustomAttr(item.attr, item.name, editorState, onChangeEditorState);
        }
      }, item.name, "\xA0\xA0", /*#__PURE__*/_react["default"].createElement("small", null, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Badge, {
        variant: item.type === "event" ? "success" : "info"
      }, item.type)));
    }) : /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Dropdown.Item, {
      disabled: true
    }, "No custom attributes"));
  };

  return {
    AddAttribute: AddAttribute
  };
};

exports["default"] = _default;
module.exports = exports.default;